// extracted by mini-css-extract-plugin
export default {"sentences":"SortSentences_sentences__dnLv1","sentenceRow":"SortSentences_sentenceRow__8+nBr","number":"SortSentences_number__f1Yp6","sentence":"SortSentences_sentence__AhJ0U"};